export const reportWebVitalsToNewRelic = (metric) => {
  if (metric && typeof window !== "undefined" && window.newrelic && metric.label !== "web-vital") {
    try {
      const name = metric.name.toLowerCase();
      const obj = {};
      if (metric.label === "custom") {
        obj[`far-ui-vitals-${name}-startTime`] = metric.startTime;
      }
      obj[`far-ui-vitals-${name}`] = metric.value;
      window.newrelic.addPageAction(`far-ui-vitals-${name}`, obj);
    } catch (e) {
      console.error("Can not report RUM data due to", e);
    }
  }
};

export default reportWebVitalsToNewRelic;
